import { useEffect, useState } from 'react';

import { useGetYandexMapScriptQuery } from '@/packages/query-state/shared/store/yandex-map/2.1/get-yandex-map/query';
import { usePropagateErrorToBoundary } from '@/packages/react-utils/usePropagateErrorToBoundary';

import { Y_MAP_ALL_MODULES } from '../constants/map';
import { useMapAppContext } from '../context/mapAppContext';
import { defineOwnYandexModulesAndLayers } from '../utils/defineOwnYandexModulesAndLayers';

export const useInitOwnYandexModulesAndLayers = (): YMaps.IYMaps | null => {
  const context = useMapAppContext();

  const propagateError = usePropagateErrorToBoundary();

  const { data: ymapsModule, isSuccess: isLoadMapScriptSuccess } = useGetYandexMapScriptQuery();

  const [ymaps, setYMaps] = useState<YMaps.IYMaps | null>(null);

  useEffect(() => {
    if (isLoadMapScriptSuccess) {
      defineOwnYandexModulesAndLayers(ymapsModule, Y_MAP_ALL_MODULES)
        .then(initializedYMaps => {
          setYMaps(initializedYMaps);
        })
        .catch(error => {
          context.logger.error(error as Error, {
            domain: '@/shared/hooks/useInitYandexMap.ts',
            message: '[Yandex Maps] Ошибка при инициализации модулей Яндекс Карт',
          });

          propagateError(error);
        });
    }
  }, [isLoadMapScriptSuccess, ymapsModule, context, propagateError, setYMaps]);

  return ymaps;
};
